/**
 *******************************************************************************
 * Google AdWords conversion tracking
 * https://support.google.com/google-ads/answer/1722054?hl=en
 * https://developers.google.com/adwords-remarketing-tag/
 *******************************************************************************
 *
 * We presume the existence of an object (probably defined in a custom script)
 * containing our conversion labels, with an array value for each
 * Mobi2Go.Analytics event name that we wish to track, e.g.
 *
 *   window.m2gGoogleAdWords = {
 *       conversionLabels: {
 *           CONFIRMED_ORDER: [
 *               'V9DrCNWuw5UBEKj5hfIC'
 *           ]
 *       }
 *   }
 *
 * Changes to the events here should be represented on the Help Center page:
 * https://support.mobi2go.com/hc/en-us/articles/360024103912
 */

/**-----------------------------------------------------------------------------
 * Load in production only, or if forced
 */

const load_analytics = /(\?|&)load_analytics/.test(document.location.search);
if (Mobi2Go.app.base_url === 'https://www.mobi2go.com' || load_analytics) {
    Mobi2Go.onReady(load);
}

function load() {
    /**-------------------------------------------------------------------------
     * Script Setup
     */
    const AW_CONVERSION_ID = Mobi2Go.headoffice.analytics_google_adwords_id;
    const CONVERSION_LABELS =
        window.m2gGoogleAdWords && window.m2gGoogleAdWords.conversionLabels;

    if (!AW_CONVERSION_ID || !CONVERSION_LABELS) {
        return;
    }

    let m2g_gtag;

    // We want to prevent gtag loading twice.
    // Some clients will include GTM in their templates when loading gtag
    // via a browser but not when loaded via the native app.
    (function() {
        // Add the gtag script to our page
        const firstScriptElement = document.getElementsByTagName('script')[0];
        const scriptElement = document.createElement('script');
        scriptElement.async = true;
        scriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${AW_CONVERSION_ID}`;
        firstScriptElement.parentNode.insertBefore(
            scriptElement,
            firstScriptElement
        );
    })();

    /**-------------------------------------------------------------------------
     * Abstraction
     */

    function startSession() {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.appName = Mobi2Go.app.getPlatform();
        window.dataLayer.appId = `${
            Mobi2Go.headoffice.domain_name
        }-${Mobi2Go.app.getPlatform()}`;
        window.dataLayer.currencyCode = Mobi2Go.headoffice.currency_abrv;

        m2g_gtag = function() {
            window.dataLayer.push(arguments);
        };
        m2g_gtag('js', new Date());
        m2g_gtag('config', AW_CONVERSION_ID);
    }

    function confirmedOrder(order) {
        const conversionLabels = CONVERSION_LABELS.CONFIRMED_ORDER || [];

        conversionLabels.forEach(function(conversionLabel) {
            m2g_gtag('event', 'purchase', {
                send_to: `${AW_CONVERSION_ID}/${conversionLabel}`,
                value: order
                    .getTotal()
                    .getTaxExclusivePrice()
                    .toFloat(),
                transaction_id: order.getId(),
            });
        });
    }

    /**-------------------------------------------------------------------------
     * Application Glue
     */
    startSession();

    Mobi2Go.Analytics.bind({
        CONFIRMED_ORDER: confirmedOrder,
    });
}
